import React from 'react';

import { useConfiguration } from '../../../hooks/Configuration';

function MessagError() {
    const configuration = useConfiguration();

    return (
        <span>{configuration?.texts.messageError}</span>
    );
}

export default MessagError;
